import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useAuth, API } from "../App";

const SubscriptionContext = createContext(null);
export const useSubscription = () => useContext(SubscriptionContext);

export const SubscriptionProvider = ({ children }) => {
  const { token, user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSub = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await axios.get(`${API}/subscription`, { headers: { Authorization: `Bearer ${token}` } });
      setData(res.data);
    } catch (e) {
      console.error("subscription fetch failed:", e?.response?.status);
    } finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchSub(); }, [fetchSub, user?.organization_id]);

  /** Check if a feature flag is enabled for current tier. Defaults to false until subscription is loaded. */
  const hasFeature = (flag) => {
    if (loading || !data?.tier?.features) return false;
    return !!data.tier.features[flag];
  };

  /** Check if a quota is exceeded (e.g., "engagements", "client_tenants"). */
  const quotaExceeded = (resource) => {
    const q = data?.quota_status?.[resource];
    return !!q && q.exceeded && !q.unlimited;
  };

  /** Get remaining quota for a resource (-1 if unlimited, undefined if unknown). */
  const quotaRemaining = (resource) => {
    const q = data?.quota_status?.[resource];
    if (!q) return undefined;
    return q.unlimited ? -1 : q.remaining;
  };

  return (
    <SubscriptionContext.Provider value={{
      subscription: data, loading, hasFeature, quotaExceeded, quotaRemaining, refresh: fetchSub
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
};
